import {Link, useParams} from "react-router-dom";
import {
  ADMIN_BLOCKED_CHILD_NAMES,
  DEFAULT_REPORT_LINKS,
  menuList,
  narrowStyle, NORMAL_CHILD_MENU_NAMES, NORMAL_MAIN_MENU_NAMES,
  ROLE,
  selectedIcon, SUPER_ADMIN_BLOCKED_CHILD_NAMES,
  widenStyle
} from "./entity";
import React, {useEffect, useMemo, useState} from "react";
import {useAtom} from "jotai";
import {reportsInfoAtom,  tokenResultAtom} from "../../pages/login/entity/Common";
import {retrieveCustomReportsList} from "../../services/reports/ReportsAxios";
import {retrieveCustomReportsAdminList} from "../../services/reports/ReportsAdminAxios";
import {DeleteReport} from "../common/DeleteReport";
import {
  AsideContainer,
  BtnNarrow, DropIcon,
  Logo,
  Menu,
  MenuIcon,
  Narrow,
  SubMenu
} from "./styles";
import {getRoleFlags} from "../../common/roleUtils";

function AsideList(props) {
  const { id, mode, role } = props;

  const params = useParams();
  const [tokenUserInfo] = useAtom(tokenResultAtom);
  const [reportsInfo, setReportsInfo] = useAtom(reportsInfoAtom);
  const [reportLists, setReportLists] = useState([]);
  const { isNormalUser, isAdminUser, isSuperAdminUser } = getRoleFlags(tokenUserInfo.role);

  const activeMenuStyle = mode ? narrowStyle.li : widenStyle.li;
  const linkModeClassName = mode ? "icon-mode" : "list-mode";
  const fadeClassName = mode ? "fadeOut" : "fadeIn";

  useEffect(() => {
    if (!tokenUserInfo.role) {
      return;
    }

    const fetchReports = isNormalUser
        ? retrieveCustomReportsList
        : retrieveCustomReportsAdminList;

    fetchReports(tokenUserInfo.id).then((response) => {
      setReportLists(response ?? []);
    });
  }, [tokenUserInfo.role, tokenUserInfo.id, reportsInfo.id, isNormalUser]);

  const availableMenus = useMemo(() => {
    return menuList.filter((menu) => canAccessMainMenu(menu, tokenUserInfo.role));
  }, [tokenUserInfo.role]);

  const handleChangeReportsInfo = (reportId, groupBy) => {
    setReportsInfo((prev) => ({
      ...prev,
      id: reportId,
      groupBy,
    }));
  };

  const isActiveMenu = (menu) => menu.include.includes(id);

  const isSelectedSubMenu = (child) => {
    return id === child.name || id === child.detail || id === child.detail2;
  };

  const getMenuIconStyle = (menuName) => {
    const isSelected = id.includes(menuName);

    return {
      backgroundImage: `url(${selectedIcon[menuName]})`,
      opacity: isSelected ? 1 : 0.5,
    };
  };

  const renderDefaultReportLinks = () => {
    return DEFAULT_REPORT_LINKS.map((report) => (
        <div key={report.id}>
          <Link
              to={report.path}
              style={id === report.id ? { color: "#fff" } : null}
              onClick={
                report.groupBy
                    ? () => handleChangeReportsInfo(0, report.groupBy)
                    : undefined
              }
          >
            {report.label}
          </Link>
        </div>
    ));
  };

  const renderCustomReportLinks = () => {
    if (!reportLists?.length) {
      return null;
    }

    return reportLists.map((report) => {
      const isSelected = report.id === reportsInfo.id;

      return (
          <div key={report.id} style={{ display: "flex", paddingRight: "5px" }}>
            <Link
                to="/board/customReports"
                onClick={() => handleChangeReportsInfo(report.id, report.groupByPeriod)}
                style={isSelected ? { color: "#fff" } : null}
            >
              {report.reportName}
            </Link>
            {isSelected && <DeleteReport reportsInfoId={report.id} />}
          </div>
      );
    });
  };

  const renderReportsSubMenu = (item) => {
    return (
        <SubMenu active={isActiveMenu(item)} length={(reportLists?.length ?? 0) + 4} maxLength={5}>
          {renderDefaultReportLinks()}
          <hr
              style={{
                width: "80%",
                marginTop: "10px",
                marginBottom: "10px",
                border: 0,
                borderTop: "1px solid #666",
              }}
          />
          {renderCustomReportLinks()}
        </SubMenu>
    );
  };

  const renderDefaultSubMenu = (item) => {
    const visibleChildren = item.child.filter((child) => canAccessChildMenu(child, role));

    return (
        <SubMenu active={isActiveMenu(item)} length={visibleChildren.length}>
          {visibleChildren.map((child) => (
              <div key={child.name}>
                <Link
                    to={`/board/${child.name}`}
                    style={isSelectedSubMenu(child) ? { color: "#fff" } : null}
                >
                  {child.header}
                </Link>
              </div>
          ))}
        </SubMenu>
    );
  };

  return (
      <>
        {availableMenus.map((item) => {
          if (params.id === undefined) {
            return null;
          }

          return (
              <div key={item.name}>
                <li
                    className={isActiveMenu(item) ? "active" : null}
                    style={activeMenuStyle}
                >
                  <Link to={`/board/${item.name}`} className={linkModeClassName}>
                    <MenuIcon style={getMenuIconStyle(item.name)} />
                    <span className={fadeClassName}>{item.header}</span>
                    {item.child.length > 0 && (
                        <DropIcon
                            className={fadeClassName}
                            style={id.includes(item.name) ? narrowStyle.button : null}
                        />
                    )}
                  </Link>

                  {item.child.length > 0 &&
                      (item.name === "reports"
                          ? renderReportsSubMenu(item)
                          : renderDefaultSubMenu(item))}
                </li>
              </div>
          );
        })}
      </>
  );
}

function canAccessMainMenu(item, userRole) {
  if ([ROLE.ADMIN, ROLE.SUPER_ADMIN].includes(userRole)) {
    return true;
  }

  if (userRole === ROLE.NORMAL) {
    return NORMAL_MAIN_MENU_NAMES.includes(item.name);
  }

  return false;
}

function canAccessChildMenu(child, role) {
  if (role === ROLE.SUPER_ADMIN) {
    return !SUPER_ADMIN_BLOCKED_CHILD_NAMES.includes(child.name);
  }

  if (role === ROLE.ADMIN) {
    return !ADMIN_BLOCKED_CHILD_NAMES.includes(child.name);
  }

  if (role === ROLE.NORMAL) {
    return NORMAL_CHILD_MENU_NAMES.includes(child.name);
  }

  return false;
}

export default function Aside() {
  const params = useParams();
  const [asideWidth, setAsideWidth] = useState(false);
  const [tokenUserInfo] = useAtom(tokenResultAtom);

  const handleChangeWidth = () => {
    setAsideWidth((prev) => !prev);
  };

  return (
      <aside>
        <AsideContainer style={asideWidth ? { width: 84 } : { width: 220 }}>
          <Logo style={asideWidth ? narrowStyle.icon : widenStyle.icon} />
          <Menu>
            <AsideList id={params.id} mode={asideWidth} role={tokenUserInfo.role} />
          </Menu>
          <Narrow>
            <button type="button" onClick={handleChangeWidth}>
              <BtnNarrow style={asideWidth ? narrowStyle.button : null} />
            </button>
          </Narrow>
        </AsideContainer>
      </aside>
  );
}
